import { controls,grouped } from "../controls";
const nominees = {
label: "Nominees",
pageLabel: "Nominees",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Account"}),
...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account Code", name: "Nominee-account-account_code",fastpath: "accounts"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Nominee-account-account_display"}),
...controls.displayText({ tab: "filter", label: "Relation"}),
...controls.autoComplete({tab: "filter", name: "Nominee-relation-relation_code", width: "col-sm-2",controlType: "Relation"}),
...controls.displayText({ tab: "filter", label: ""}),
]
,form:[
...controls.displayText({ tab: "general", label: "Full Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "full_name",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.magicDateLabel({ tab: "general", label: "Date of Birth",target: "dob",star:false}),
...controls.magicDate({ tab: "general", name: "dob", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Age",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "age",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Share"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "share",maxlength:6}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Guardian Descn",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "guardian_descn",maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Relation",star:true}),
...controls.autoComplete({tab: "general", name: "relation_code", width: "col-sm-2",controlType: "Relation"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Nominee Doc Type",star:false}),
...controls.oc({ tab: "general", c: "DocumentType", placeHolder: "Nominee Doc Type", name: "nominee_document_type_code",fastpath: "document_types",displayData:{document_type_display:"nominee_document_type_display",document_type_uid:"nominee_document_type_uid"},hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "nominee_document_type_display"}),
...controls.displayText({ tab: "general", label: "Doc No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "nominee_document_no",maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Guardian Doc Type",star:false}),
...controls.oc({ tab: "general", c: "DocumentType", placeHolder: "Guardian Doc Type", name: "guardian_document_type_code",fastpath: "document_types",displayData:{document_type_display:"guardian_document_type_display",document_type_uid:"guardian_document_type_uid"},hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "guardian_document_type_display"}),
...controls.displayText({ tab: "general", label: "Doc No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "guardian_document_no",maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Nominee Phone",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "nominee_phone",maxlength:13}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Guardian Phone",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "guardian_phone",maxlength:13}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Nominee Address",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "nominee_address",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Guardian Address",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "guardian_address",width:"col-sm-4",maxlength:100}),
]
,history:{
perPage: 10,
reportHeader: "Nominees",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Full Name",accessor: "full_name",},
{Header: "Date of Birth",accessor: "dob",type:'date'},
{Header: "Age",accessor: "age",},
{Header: "Share",accessor: "share",},
{Header: "Guardian Descn",accessor: "guardian_descn",},
{Header: "Account Id",accessor: "account_id",},
{Header: "Relation Id",accessor: "relation_id",},
{Header: "Nominee Doc Type",accessor: "nominee_document_type_id",},
{Header: "Doc No",accessor: "nominee_document_no",},
{Header: "Guardian Doc Type",accessor: "guardian_document_type_id",},
{Header: "Doc No",accessor: "guardian_document_no",},
{Header: "Nominee Phone",accessor: "nominee_phone",},
{Header: "Guardian Phone",accessor: "guardian_phone",},
{Header: "Nominee Address",accessor: "nominee_address",},
{Header: "Guardian Address",accessor: "guardian_address",},
]}};
export default nominees;